import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  AiToneOfVoicesQuery,
  CreateAiToneOfVoiceMutation,
  CreateAiToneOfVoiceMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const createAiToneOfVoice = graphql(`
  mutation createAiToneOfVoice($input: CreateAiToneOfVoiceRequest!) {
    createAiToneOfVoice(input: $input) {
      id
      label
      rawValue
      isDefault
      companyId
      teamId
      sourceDocumentId
      createdAt
      updatedAt
    }
  }
`);

export function useCreateAiToneOfVoice(
  options?: UseMutationOptions<
    CreateAiToneOfVoiceMutation,
    unknown,
    CreateAiToneOfVoiceMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();

  const { data, ...rest } = useGraphQlMutation(createAiToneOfVoice, {
    ...options,
    onSuccess: async (data, variables, context) => {
      // No point in just appending, if it's changing default for example -
      //  it's best to refetch
      if (variables.input.isDefault === true) {
        await queryClient.invalidateQueries({ queryKey: ["aiToneOfVoices"] });
      } else {
        const created = data.createAiToneOfVoice;
        queryClient.setQueryData(["aiToneOfVoices"], (prev: AiToneOfVoicesQuery | undefined) => {
          if (!prev) return prev;
          return {
            aiToneOfVoices: {
              results: [...prev.aiToneOfVoices.results, created],
            },
          };
        });
      }
      options?.onSuccess?.(data, variables, context);
    },
  });

  return { data: data?.createAiToneOfVoice, ...rest };
}
